import { render } from "./userRoles.vue?vue&type=template&id=e4d84f12"
import script from "./userRoles.vue?vue&type=script&lang=js"
export * from "./userRoles.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__